import { useState, useCallback } from 'react';
import { clampWeek, TIME_MACHINE_CONFIG } from '../lib/time-machine.utils';

interface UseTimeMachineOptions {
  minWeek?: number;
  maxWeek?: number;
}

export interface UseTimeMachine {
  currentWeek: number;
  minWeek: number;
  maxWeek: number;
  setWeek: (week: number) => void;
  stepBackward: () => void;
  stepForward: () => void;
  reset: () => void;
}

export function useTimeMachine(options: UseTimeMachineOptions = {}): UseTimeMachine {
  const { minWeek = TIME_MACHINE_CONFIG.DEFAULT_MIN_WEEK, maxWeek = TIME_MACHINE_CONFIG.DEFAULT_MAX_WEEK } = options;
  const [currentWeek, setCurrentWeek] = useState(maxWeek);

  const setWeek = useCallback(
    (week: number) => {
      setCurrentWeek(clampWeek(week, minWeek, maxWeek));
    },
    [minWeek, maxWeek]
  );

  const stepForward = useCallback(() => {
    setCurrentWeek((prev) => clampWeek(prev + 1, minWeek, maxWeek));
  }, [minWeek, maxWeek]);

  const stepBackward = useCallback(() => {
    setCurrentWeek((prev) => clampWeek(prev - 1, minWeek, maxWeek));
  }, [minWeek, maxWeek]);

  const reset = useCallback(() => {
    setCurrentWeek(maxWeek);
  }, [maxWeek]);

  return {
    currentWeek,
    minWeek,
    maxWeek,
    setWeek,
    stepForward,
    stepBackward,
    reset
  };
}
